module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-white overflow-hidden position-relative width-100",
    attrs: {
      "id": "intro"
    }
  }, [_c('div', {
    staticClass: "container-fluid no-padding"
  }, [_c('div', {
    staticClass: "row no-padding-rl xs-padding-6 padding-4"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-1 text-gray-dark-2 text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.intro))]), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-2 margin-1 no-margin-bottom text-gray-dark-2 text-uppercase xs-text-extra-large title-large"
  }, [_vm._v("Du kommer til at opleve:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "features-box col-md-4 no-padding text-center"
  }, [_c('div', {
    staticClass: "bg-cover bg-overlay-black-4 overflow-hidden position-relative",
    style: ('background-image: url(' + _vm.firstPicture + ')')
  }, [_c('div', {
    staticClass: "height-100 position-absolute position-top position-left width-100"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell text-center vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-2 text-medium text-uppercase text-white"
  }, [_vm._v(_vm._s(_vm.firstText))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "features-box col-md-4 no-padding text-center"
  }, [_c('div', {
    staticClass: "bg-cover bg-overlay-black-4 overflow-hidden position-relative",
    style: ('background-image: url(' + _vm.secondPicture + ')')
  }, [_c('div', {
    staticClass: "height-100 position-absolute position-top position-left width-100"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell text-center vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-2 text-medium text-uppercase text-white"
  }, [_vm._v(_vm._s(_vm.secondText))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "features-box col-md-4 no-padding text-center"
  }, [_c('div', {
    staticClass: "bg-cover bg-overlay-black-4 overflow-hidden position-relative",
    style: ('background-image: url(' + _vm.thirdPicture + ')')
  }, [_c('div', {
    staticClass: "height-100 position-absolute position-top position-left width-100"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell text-center vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-2 text-medium text-uppercase text-white"
  }, [_vm._v(_vm._s(_vm.thirdText))])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41d85677"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-sections/boxes.vue
// module id = 239
// module chunks = 1